export enum PaperColorType {
  BlackWhite,
  Colored,
}